import React, { useState, useEffect } from 'react';
import './Typewriter.css'; // We'll create this CSS file next

const Typewriter = ({ text, delay = 100, isEnabled = true, shouldLoop = false }) => {
    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTyping, setIsTyping] = useState(true);

    // Reset when the animation is disabled or settings change
    useEffect(() => {
        if (!isEnabled) {
            setCurrentText(text);
            setCurrentIndex(text.length);
            setIsTyping(false);
        } else {
            setCurrentText('');
            setCurrentIndex(0);
            setIsTyping(true);
        }
    }, [isEnabled, text]);

    // Typing effect with variable timing for more natural effect
    useEffect(() => {
        if (isEnabled && isTyping && currentIndex < text.length) {
            // Add slight randomization to typing speed for more natural feel
            const variance = Math.random() * 50 - 25; // -25 to +25ms variance
            const typingDelay = delay + variance;

            const timeout = setTimeout(() => {
                setCurrentText(prevText => prevText + text[currentIndex]);
                setCurrentIndex(prevIndex => prevIndex + 1);
            }, typingDelay);

            return () => clearTimeout(timeout);
        } else if (isEnabled && isTyping && currentIndex >= text.length) {
            // Pause at the end before restarting if loop is enabled
            if (shouldLoop) {
                const pauseTimeout = setTimeout(() => {
                    if (isEnabled) {
                        setCurrentText('');
                        setCurrentIndex(0);
                    }
                }, 3000); // 3 second pause before restarting

                return () => clearTimeout(pauseTimeout);
            }
        }
    }, [currentIndex, delay, text, isEnabled, isTyping, shouldLoop]);

    return (
        <span className="typewriter-text">
            {currentText}
            <span className={`cursor ${isEnabled ? 'blinking' : 'hidden'}`}></span>
        </span>
    );
};

export default Typewriter; 